import React, { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { contactColumns } from "../../Data/ContactList";
import { paginationComponentOptions } from "../../../../Shared/Constants/DatatableConstants";
import { ContactContext } from "../../ContextProvider";
import TableButtons from "../../../../Shared/Components/TableButtons";
import { useNavigate } from "react-router";
import { deleteConfirmationModal } from "../../../../Shared/Components/DeleteConfrimationModal";

const ContactsTableData = ({ showDeleteButton, showEditButton }) => {

  const {
    tableData,
    setRowsPerPage,
    setCurrentPage,
    currentPage,
    loading,
    rowsPerPage,
    deleteItem,
    totalRows,
    fetchTableData,
    handleEdit,
    searchTerm,
    filters,
    setFilters,
    setSelectedRows,

    //aqui me quede
  } = useContext(ContactContext);
  const navigate = useNavigate();
  const [colums, setColums] = useState([]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const handleDelete = (row) => {
    deleteConfirmationModal(row.id, deleteItem);
  };
  const onEditClick = async (row) => {
    handleEdit(row);
    navigate(`${process.env.PUBLIC_URL}/app/contacts/edit/${row.id}`);
  };

  const handleView = (row) => {
    handleEdit(row);
    navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${row.id}`);
  };


  const handleSelected = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
    console.log(selectedRows);

  };




  const customTableStyles = {
    selectableRowsHeader: {
      style: {
        width: '32px',       // Tamaño más pequeño del checkbox header
        maxWidth: '32px',
        paddingLeft: '8px',
        paddingRight: '0px',
        justifyContent: 'center',
      },
    },
    selectableRows: {
      style: {
        width: '32px',       // Tamaño más pequeño del checkbox de fila
        maxWidth: '32px',
        paddingLeft: '8px',
        paddingRight: '0px',
        justifyContent: 'center',
      },
    },
    headCells: {
      style: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
    cells: {
      style: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    },
  };



  useEffect(() => {
    return () => {
      setFilters({});
    };
  }, []);

  useEffect(() => {
    setColums([
      ...contactColumns,
      {
        name: "Acciones",
        width: "250px",
        cell: (row) => (
          <TableButtons
            handleEdit={onEditClick}
            handleDelete={handleDelete}
            row={row}
            showViewButton={true}
            handleView={handleView}
            entity={"contact"}
            showEditButton={showEditButton}
            showDeleteButton={showDeleteButton}
          ></TableButtons>
        ),
        ignoreRowClick: true, // Prevent action buttons from triggering row selection
        allowOverflow: true, // Prevent layout overflow issues
        button: true, // Indicate that it's a button column
      },
    ]);
  }, [tableData]);

  useEffect(() => {
    fetchTableData(currentPage, rowsPerPage);
  }, [currentPage, searchTerm, filters]);
  return (
    <Fragment>
      <div className="table-responsive product-table">
        <div id="basic-1_wrapper" className="dataTables_wrapper no-footer">
          <DataTable
            selectableRows
            className="display dataTable no-footer"
            noHeader
            customStyles={customTableStyles}
            onSelectedRowsChange={handleSelected}
            data={tableData}
            columns={colums}
            striped={true}
            center={false}
            pagination
            paginationServer // Enables server-side pagination
            paginationTotalRows={totalRows} // Pass total rows to DataTable
            paginationComponentOptions={paginationComponentOptions}
            paginationDefaultPage={currentPage} // Default current page
            paginationPerPage={rowsPerPage} // Rows per page
            onChangePage={handlePageChange} // Handle page change
            onChangeRowsPerPage={handleRowsPerPageChange} // Handle rows per page change
            progressPending={loading} // Show loading spinner
          />
        </div>
      </div>
    </Fragment>
  );
};
export default ContactsTableData;
